module.exports = "/fonts/Montserrat-Bold.ttf?88932dadc42e1bba93b21a76de60ef7a";